/**
 * DeliveryPage Component
 * 배달 통합 페이지 - 요약/상세 탭
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import BottomNavigation from '../../../../core/components/BottomNavigation';
import BalanceDisplay from './shared/BalanceDisplay';
import { DeliverySummaryTab } from './DeliverySummaryTab';
import { DeliveryDetailTab } from './DeliveryDetailTab';
import { getUserInfo } from '../../../../core/utils';
import styles from '../styles/DeliveryPage.module.css';

type TabType = 'summary' | 'detail';

const DeliveryPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState<TabType>('summary');

    const riderName = useMemo(() => {
        const userInfo = getUserInfo();
        return userInfo?.riderName || '사용자';
    }, []);

    // URL 파라미터에서 탭 읽기
    useEffect(() => {
        const tab = searchParams.get('tab') as TabType;
        if (tab === 'summary' || tab === 'detail') {
            setActiveTab(tab);
        }
    }, [searchParams]);

    const handleTabChange = (tab: TabType) => {
        setActiveTab(tab);
        setSearchParams({ tab });
    };

    const goToMyPage = () => {
        navigate('/my-page');
    };

    return (
        <div className={`screen active ${styles['delivery-screen']}`}>
            {/* 헤더 */}
            <div className={styles['delivery-header']}>
                <div className={styles['header-top']}>
                    <h1 className={styles['page-title']}>
                        <span className={styles['greeting-name']}>{riderName}</span>님 안녕하세요
                    </h1>
                    <div className={styles['header-actions']}>
                        <BalanceDisplay />
                        <button className={styles['settings-btn']} onClick={goToMyPage}>
                            <i className="fas fa-cog"></i>
                        </button>
                    </div>
                </div>
                
                {/* 탭 */}
                <div className={styles['tabs']}>
                    <button
                        className={`${styles['tab']} ${activeTab === 'summary' ? styles['tab-active'] : ''}`}
                        onClick={() => handleTabChange('summary')}
                    >
                        요약
                    </button>
                    <button
                        className={`${styles['tab']} ${activeTab === 'detail' ? styles['tab-active'] : ''}`}
                        onClick={() => handleTabChange('detail')}
                    >
                        상세
                    </button>
                </div>
            </div>

            {/* 탭 컨텐츠 */}
            <div className={styles['tab-content']}>
                {activeTab === 'summary' ? (
                    <DeliverySummaryTab />
                ) : (
                    <DeliveryDetailTab />
                )}
            </div>

            {/* 하단 네비게이션 */}
            <BottomNavigation currentScreen="delivery" />
        </div>
    );
};

export default DeliveryPage;
